import { Component } from '@angular/core';
import { INoRowsOverlayComp } from 'ag-grid-enterprise';

@Component({
  selector: 'app-grid-no-rows-overlay',
  templateUrl: './no-rows-overlay.component.html',
  standalone: false,
})
export class GridNoRowsOverlay implements INoRowsOverlayComp {
  params!: { message: string };

  agInit(params: any): void {
    this.params = params;
  }

  getGui(): HTMLElement {
    return '' as unknown as HTMLElement;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }
}
